export default {
  title: "Benachrichtigungen",
  unread: "{{count}} ungelesen",
  unread_plural: "{{count}} ungelesen",
  allRead: "Alles aktuell",
  viewAll: "Alle anzeigen",
  markAsRead: "Als gelesen markieren",
  markAllAsRead: "Alle als gelesen markieren",
  empty: "Keine Benachrichtigungen",
  viewMore: "Mehr anzeigen",
  noNotifications: "Keine Benachrichtigungen",
  types: {
    info: "Information",
    warning: "Achtung",
    error: "Fehler",
    success: "Erfolg"
  },
  actions: {
    view: "Ansehen",
    dismiss: "Ignorieren",
    accept: "Akzeptieren",
    decline: "Ablehnen"
  },
  categories: {
    system: "System",
    tasks: "Aufgaben",
    guests: "Gäste",
    budget: "Budget",
    vendors: "Dienstleister",
    timeline: "Planung",
    achievements: "Erfolg",
    weddingWebsite: "Hochzeitswebsite"
  },
  settings: {
    title: "Benachrichtigungseinstellungen",
    push: {
      title: "Push-Benachrichtigungen",
      description: "Erhalten Sie Benachrichtigungen, auch wenn Sie die App nicht verwenden"
    },
    categories: {
      title: "Benachrichtigungskategorien"
    },
    other: {
      title: "Andere Benachrichtigungen",
      email: {
        title: "E-Mail-Benachrichtigungen",
        description: "Erhalten Sie wichtige Updates per E-Mail"
      },
      desktop: {
        title: "Desktop-Benachrichtigungen",
        description: "Erhalten Sie Benachrichtigungen auf Ihrem Computer"
      }
    },
    testButton: "Benachrichtigungen testen"
  },
  errors: {
    loadPreferences: "Fehler beim Laden der Einstellungen",
    pushToggle: "Fehler beim Ändern der Push-Benachrichtigungen",
    categoryToggle: "Fehler beim Ändern der Kategorien"
  }
};
